import React from "react";
import { BlockBand } from "./Decor";
import { GiRoundStar } from "react-icons/gi";
import { FaGem, FaBalanceScale } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";

const stats = [
  { Ic: GiRoundStar, value: "4", label: "Generations of Trust" },
  { Ic: FaGem, value: "916", label: "Hallmark Purity" },
  { Ic: FiHeart, value: "5000+", label: "Happy Families" },
  { Ic: FaBalanceScale, value: "100%", label: "Transparent Weighing" },
];

export default function Stats() {
  return (
    <section className="relative bg-coffee-800 text-cream">
      <BlockBand className="block h-5 w-full text-gold/40" flip />
      <div className="container-x grid grid-cols-2 gap-y-10 py-14 md:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="reveal text-center">
            <s.Ic className="mx-auto text-2xl text-gold-light" />
            <div className="mt-2 font-display text-4xl text-gold-light">{s.value}</div>
            <div className="mx-auto mt-1 h-px w-10 bg-gold/50" />
            <div className="mt-2 text-[0.78rem] uppercase tracking-[0.18em] text-cream/75">
              {s.label}
            </div>
          </div>
        ))}
      </div>
      <BlockBand className="block h-5 w-full text-gold/40" />
    </section>
  );
}
